export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}

export function formatNum(n: number | undefined | null, digits = 0): string {
  if (n == null || Number.isNaN(n)) return '—'
  return n.toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  })
}

export function formatKD(kd: number): string {
  return formatNum(kd, 2)
}

export function formatPct(n: number): string {
  return `${formatNum(n, 1)}%`
}

export function sideColor(side: string): string {
  const s = side?.toUpperCase()
  if (s === 'WEST' || s === 'BLUFOR') return 'text-sky-400/90'
  if (s === 'EAST' || s === 'OPFOR') return 'text-red-400/90'
  if (s === 'GUER' || s === 'INDEPENDENT') return 'text-emerald-500/90'
  if (s === 'CIV' || s === 'CIVILIAN') return 'text-amber-500/80'
  return 'text-ink-muted'
}

export function sideBg(side: string): string {
  const s = side?.toUpperCase()
  if (s === 'WEST' || s === 'BLUFOR') return 'bg-sky-500'
  if (s === 'EAST' || s === 'OPFOR') return 'bg-red-500'
  if (s === 'GUER' || s === 'INDEPENDENT') return 'bg-emerald-600'
  if (s === 'CIV' || s === 'CIVILIAN') return 'bg-amber-600'
  return 'bg-ink-faint'
}

export function formatDistance(d: string | number | undefined | null): string {
  if (d == null || d === '') return '—'
  const s = String(d)
  return s.endsWith('m') ? s : `${s}m`
}
